import merge from 'deepmerge';

export const deepMerge = (initialData, newData) => {
  const overwriteMerge = (destinationArray, sourceArray) => sourceArray;

  return merge(
    JSON.parse(JSON.stringify(initialData)),
    JSON.parse(JSON.stringify(newData)),
    { arrayMerge: overwriteMerge }
  );
};